import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";
import { IIPRestrictionListRequest, IIPRestrictionListResponse } from "./_types";

async function getIPRestrictionList(
  data: IIPRestrictionListRequest
): Promise<BaseResponse<IIPRestrictionListResponse>> {
  try {
    return (await axiosInstance.post("/IPRestriction/List", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetIPRestrictionList() {
  return useMutation<
    BaseResponse<IIPRestrictionListResponse>,
    Error,
    IIPRestrictionListRequest
  >((variables) => getIPRestrictionList(variables));
}
